import { useLoadExternalConfig } from '../hooks/useLoadExternalConfig'

export function ExternalConfigLoader() {
  useLoadExternalConfig(`${process.env.PUBLIC_CONFIG_PATH || ''}/config.json`)

  return null
}
